import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import UserService from '../../services/UserService';
import { DualAuthService } from '../../services/DualAuthService';
import { RegistrationStatus } from '../../models/RegistrationStatus';

@Component({
  selector: 'app-customer-landing',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule, MatButtonModule],
  template: `
    <div class="landing">
      <mat-icon class="brand">person</mat-icon>
      <h2 *ngIf="state==='loading'">Setting up your account…</h2>
      <h2 *ngIf="state==='created'">Your account is ready!</h2>
      <h2 *ngIf="state==='existing'">Welcome back.</h2>
      <h2 *ngIf="state==='error'">We couldn't initialize your account</h2>
      <p *ngIf="state==='loading'">Please wait while we initialize your profile.</p>
      <p *ngIf="state==='created'">We created your customer profile.</p>
      <p *ngIf="state==='existing'">Taking you to your orders…</p>
      <p *ngIf="state==='error'">You can still continue to your orders.</p>
      <mat-progress-spinner *ngIf="state==='loading'" mode="indeterminate" diameter="48"></mat-progress-spinner>
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="goOrders()">Continue</button>
      </div>
    </div>
  `,
  styles: [
    `.landing { display:flex; flex-direction:column; align-items:center; gap:12px; padding:48px 16px; }`,
    `.brand { font-size:40px; color:#1976d2; }`,
    `.actions { margin-top:8px; }`
  ]
})
export class CustomerLandingComponent implements OnInit {
  state: 'loading' | 'created' | 'existing' | 'error' = 'loading';
  constructor(
    private userService: UserService,
    private dualAuth: DualAuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Ensure we have a CIAM token; if not, trigger redirect login
    this.dualAuth.getAccessToken().subscribe({
      next: (token) => {
        if (!token) {
          // No token yet; start CIAM redirect login and let redirect handler continue the flow
          try { this.dualAuth.loginCustomerCiamRedirect(); } catch {}
          return;
        }
        this.callGetMe();
      },
      error: () => {
        try { this.dualAuth.loginCustomerCiamRedirect(); } catch {}
      },
    });
  }

  private callGetMe(): void {
    this.userService.getMe().subscribe({
      next: (response) => {
        // Check if user is a customer
        if (response.userType !== 'customer' || !response.customer) {
          this.state = 'error';
          this.router.navigate(['/']);
          return;
        }

        const customer = response.customer;
        const status: RegistrationStatus | undefined = customer?.registrationStatus;
        const isActive = !!customer?.isActive;
        
        if (status === RegistrationStatus.Pending || !isActive) {
          this.state = 'existing';
          this.router.navigate(['customer/pending']);
          return;
        }

        // Note: The new endpoint auto-creates, so we can't distinguish 201 vs 200
        // We'll assume existing for now
        this.state = 'existing';
        setTimeout(() => this.goOrders(), 500);
      },
      error: () => {
        this.state = 'error';
        setTimeout(() => this.goOrders(), 800);
      },
    });
  }

  goOrders(): void {
    this.router.navigate(['orders']);
  }
}
